//处理德州中图集
const {ccclass, property} = cc._decorator;

@ccclass
export default class AtlasHandleComp extends cc.Component {
    @property(cc.SpriteAtlas)
    spriteAtlasPoker: cc.SpriteAtlas = null

    @property([cc.Sprite])
    target:cc.Sprite[] = [];

    fillSprites(name:string[]){
        for (let i = 0; i < this.target.length; i++) {
            let node = this.target[i];
            node.spriteFrame = null;
            node.spriteFrame = this.getSpriteFrameByName(name[i]);
        }
    }

    protected getSpriteFrameByName(key: string){
        return this.spriteAtlasPoker.getSpriteFrame(key)
    }
}
